<div
  [ngClass]="{ show: alert$ | async, error: (alert$ | async)?.isError }"
  class="alert"
>
  <div
    role="button"
    tabindex="0"
    (keydown.enter)="close()"
    (keydown.space)="$event.preventDefault(); close()"
    *ngIf="canClose && alert$ | async"
    class="alert__close"
    (click)="close()"
  >
    <mat-icon class="close-icon" svgIcon="close"></mat-icon>
  </div>
  <div *ngIf="alert$ | async" class="alert__content">
    <mat-icon svgIcon="warning-circle"></mat-icon>
    <span>{{ (alert$ | async).message }}</span>
  </div>
</div>
